import { defineMessages, useIntl } from 'react-intl';

export const usePageNumberTranslation = (pageNumber: number) => {
  const intl = useIntl();
  const pageNumberTranslation =
    pageNumber > 1
      ? (intl.formatMessage(messages.page, { pageNumber }) as string)
      : '';

  return pageNumberTranslation;
};

const messages = defineMessages({
  page: {
    id: 'meta_page-number',
    defaultMessage: 'Page {pageNumber} - ',
  },
});
